export default "__VITE_ASSET__1c727781__"